import React from 'react';
import { Routes, Route, Navigate } from 'react-router';
import { EnterPage, InvestorRegStart, InvestorReg, LoginViaEmail, ResetPassword } from '@/pages';
import { AgentRegStart } from '@/pages/registration/agent';
import { AssistantRegStart } from '@/pages/registration/assistant';
import { RegLoginLayout } from '@/layouts/RegLoginLayout';

export const RegLoginRoutes = () => {
  return (
    <Routes>
      <Route element={<RegLoginLayout />}>
        <Route index element={<EnterPage />} />

        <Route path='registration'>
          <Route path='investor'>
            <Route index element={<InvestorRegStart />} />
            <Route path=':page' element={<InvestorReg />} />
          </Route>
          <Route path='agent'>
            <Route index element={<AgentRegStart />} />
            <Route path=':page' element={<InvestorReg />} />
          </Route>
          <Route path='assistant'>
            <Route index element={<AssistantRegStart />} />
            <Route path=':page' element={<InvestorReg />} />
          </Route>
        </Route>

        <Route path='login' element={<LoginViaEmail />} />

        <Route path='reset-password' element={<ResetPassword />} />
      </Route>

      {/* Fallback route */}
      <Route path='*' element={<Navigate to='/' replace />} />
    </Routes>
  );
};
